export class StringHelper {
  static isNumber(value: any): boolean {
    return typeof value === 'number' || (typeof value === 'string' && !!value);
  }
  static toNumber(value: any): number {
    const number = parseFloat(value);
    return isNaN(number) ? 0 : number;
  }
}
export const shortUUID = (value: string): string => {
  return value.replace(/-/g, '').toLowerCase();
};
